import React, { useState, useEffect } from 'react';
import { useParams } from 'react-router-dom';
import axios from 'axios';
import {
    Box,
    Typography,
    Table,
    TableBody,
    MenuItem,
    Select,
    TableCell,
    TableContainer,
    TableHead,
    TableRow,
    Paper,
    TextField,
    InputAdornment,
    TablePagination,
    Avatar,
    Collapse,
    IconButton,
} from '@mui/material';
import SearchIcon from '@mui/icons-material/Search';
import PrintIcon from '@mui/icons-material/Print';
import { printData } from '../Reports/Print/printData';
import { styled, keyframes } from '@mui/system';
import HomeIcon from '@mui/icons-material/Home';
import ScrollToTopButton from '../Button/ScrollToTopButton';
import { motion } from 'framer-motion';
import { useNavigate } from "react-router-dom";
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown';
import KeyboardArrowUpIcon from '@mui/icons-material/KeyboardArrowUp';
import DeleteIcon from '@mui/icons-material/Delete';
import { Notyf } from 'notyf';

const notyf = new Notyf({
    position: { x: 'left', y: 'bottom' },
    duration: 3000,
});

const slideInFromLeft = keyframes`
  0% {
    transform: translateX(-20px);
    opacity: 0;
  }
  100% {
    transform: translateX(0);
    opacity: 1;
  }
`;

const AnimatedTypography = styled(Typography)(({ theme }) => ({
    animation: `${slideInFromLeft} 0.5s ease-out`,
}));

const OrderHistory = ({ orderId }) => {
    const [user, setUser] = useState({});
    const [token, setToken] = useState(() => localStorage.getItem('token') || null);
    const { fullname } = useParams();
    const [orders, setOrders] = useState([]);
    const [customers, setCustomers] = useState([]);
    const [loading, setLoading] = useState(false);
    const [filteredData, setFilteredData] = useState([]);
    const [searchTerm, setSearchTerm] = useState('');
    const [page, setPage] = useState(0);
    const [rowsPerPage, setRowsPerPage] = useState(100);
    const [customerInfo, setCustomerInfo] = useState(null);
    const [selectedMonth, setSelectedMonth] = useState('');
    const [payments, setPayments] = useState([]);
    const [orderpayments, setOrderPayments] = useState([]);
    const [totalPaymentAmount, setTotalPaymentAmount] = useState(0);
    const [totalOrderPayAmount, setTotalOrderPayAmount] = useState(0);
    const [paymentIds, setPaymentIds] = useState([]);
    const [isSearchOpen, setIsSearchOpen] = useState(false);
    const navigate = useNavigate();

    const [openRow, setOpenRow] = useState(null);

    const handleToggleRow = (orderId) => {
        setOpenRow(openRow === orderId ? null : orderId);
    };

    const toggleSearch = () => {
        setIsSearchOpen(!isSearchOpen);
    };


    {/**useEffect(() => {
        if (token) {
            localStorage.setItem('token', token);
        }
    }, [token]);
    
    useEffect(() => {
        const fetchProfile = async () => {
            if (!token) return; // Exit if no token
    
            try {
                const response = await axios.get('https://admin.bizstor.lk/public/api/profile', {
                    headers: {
                        Authorization: `Bearer ${token}`,
                    },
                });
                setUser(response.data);
            } catch (error) {
                console.log('');
            }
        };
    
        fetchProfile();
    }, [token]);*/}


    useEffect(() => {
        const fetchProfile = async () => {
            const token = localStorage.getItem("token");

            if (!token) {
                navigate("/"); // Redirect if no token
                return;
            }

            try {
                const response = await axios.get("https://admin.bizstor.lk/public/api/profile", {
                    headers: { Authorization: `Bearer ${token}` },
                });
                setUser(response.data);
            } catch (error) {
                if (error.response && error.response.status === 401) {
                    localStorage.removeItem("token");
                    navigate("/"); // Redirect on 401 error
                }
            }
        };

        fetchProfile();
    }, []);

    useEffect(() => {
        if (user.id) {
            fetchOrdersAndCustomers();
            fetchPaymentData();
        }
    }, [user.id]);



    const fetchOrdersAndCustomers = async () => {
        setLoading(true);
        try {
            const [ordersResponse, customersResponse] = await Promise.all([
                axios.get('https://admin.bizstor.lk/public/api/get-data'),
                axios.get('https://admin.bizstor.lk/public/api/get-customer-data')
            ]);

            const userId = user.id; // Ensure user.id is defined

            // Initialize the Orders variable
            let Orders = [];

            if (userId) {

                // Filter orders based on userId
                Orders = ordersResponse.data.filter(order =>
                    order.usertoken.toLowerCase() === userId.toString().toLowerCase()
                );
            } else {
                // If userId is not available, use all orders
                Orders = ordersResponse.data;
            }

            let Customer = [];

            if (userId) {


                // Filter orders based on userId
                Customer = customersResponse.data.customers.filter(customer =>
                    customer.usertoken.toLowerCase() === userId.toString().toLowerCase()
                );
            } else {
                // If userId is not available, use all orders
                Customer = customersResponse.data.customers;
            }


            // Filter orders based on the provided fullname
            const filteredOrders = Orders.filter(order => order.fullname === fullname);
            setOrders(filteredOrders);
            setFilteredData(filteredOrders);

            // Find customer information
            const matchedCustomer = Customer.find(customer => customer.firstname === fullname);
            if (matchedCustomer) {
                setCustomerInfo({
                    address: matchedCustomer.address,
                    image: matchedCustomer.image
                });
            } else {
                setCustomerInfo(null);
            }
        } catch (error) {
            console.error('Error fetching data:', error);
        } finally {
            setLoading(false);
        }
    };

    useEffect(() => {
        fetchOrdersAndCustomers();
    }, [fullname]);

    const calculateTotals = (data) => {
        let totalQuantity = 0;
        let totalAmount = 0;

        data.forEach(order => {
            let orderTotal = 0;
            order.items.forEach(item => {
                totalQuantity += Number(item.quantity);
                const itemTax = (Number(item.price) * (item.tax / 100)) || 0;
                const itemTotal = Number(item.price) + itemTax;
                orderTotal += itemTotal;
            });

            const discountPercentage = order.discount || 0;
            const discountAmount = (orderTotal * discountPercentage) / 100;
            const finalAmount = orderTotal - discountAmount;
            totalAmount += finalAmount;
        });

        return { totalQuantity, totalAmount };
    };

    const { totalQuantity, totalAmount } = calculateTotals(filteredData);

    const handleSearchChange = (event) => {
        const value = event.target.value.toLowerCase();
        setSearchTerm(value);
        filterData(value, selectedMonth);
    };

    const handleMonthChange = (event) => {
        const month = event.target.value;
        setSelectedMonth(month);
        filterData(searchTerm, month);
    };

    const filterData = (term, month) => {
        const filtered = orders.filter(order => {
            const orderDate = new Date(order.invoicedate);
            const orderMonth = orderDate.toLocaleString('default', { month: 'long' });

            return (order.id.toString().includes(term) ||
                order.invoicedate.toLowerCase().includes(term)) &&
                (!month || orderMonth === month);
        });
        setFilteredData(filtered);
    };

    const handleChangePage = (event, newPage) => {
        setPage(newPage);
    };

    const handleChangeRowsPerPage = (event) => {
        setRowsPerPage(parseInt(event.target.value, 10));
        setPage(0);
    };

    const handlePrint = () => {

        const printDataParams = {
            filteredData,
            fullname,
            totalQuantity,
            totalAmount,
            selectedMonth
        };
        printData(printDataParams);
    };



    useEffect(() => {
        // Extract order.id values into paymentIds array
        const ids = orders.map(order => order.id);
        setPaymentIds(ids);
    }, [orders]);

    const fetchPaymentData = async () => {
        setLoading(true);
        try {
            const response = await axios.get('https://admin.bizstor.lk/public/api/get-payment-data');

            if (user.id) {
                // Filter payments based on user token
                const userPayments = response.data.filter(payment =>
                    payment.usertoken === user.id.toString()
                );
                setOrderPayments(userPayments); // This will trigger the useEffect
            }
        } catch (error) {
            console.error('Error fetching payment data:', error);
        } finally {
            setLoading(false);
        }
    };

    useEffect(() => {
        // Only run the filtering when orderpayments or paymentIds change
        const filteredPayments = orderpayments.filter(payment =>
            paymentIds.includes(payment.payment_id)
        );

        setPayments(filteredPayments);

        // Calculate the total amount
        const total = filteredPayments.reduce((acc, payment) => acc + Number(payment.amount), 0);
        setTotalPaymentAmount(total);
    }, [orderpayments, paymentIds]);


    useEffect(() => {
        if (paymentIds.length > 0) {
            fetchPaymentData();
        }
    }, [paymentIds]);


    const calculateTotalPayAmount = (orders) => {
        return orders.reduce((total, order) => {
            return total + Number(order.payamount);
        }, 0);
    };

    const totalPayAmount = calculateTotalPayAmount(orders);

    const totalFinalAmount = filteredData.reduce((acc, order) => {
        if (order.term !== 'due on receipt') {
            order.items.forEach(item => {
                const itemTax = (Number(item.price) * (item.tax / 100)) || 0;
                const itemTotal = Number(item.price) + itemTax;
                const discountPercentage = order.discount || 0;
                const discountAmount = (itemTotal * discountPercentage) / 100;
                const finalAmount = itemTotal - discountAmount;
                acc += finalAmount;
            });
        }
        return acc;
    }, 0);

    const handleBackClick = () => {
        navigate("/report-customers");
    };

    const calculateOrderTotal = (order) => {
        return order.items.reduce((acc, item) => {
            const itemTax = (Number(item.price) * (item.tax / 100)) || 0;
            const itemTotal = Number(item.price) + itemTax;
            const discount = order.discount || 0;
            const discountAmount = (itemTotal * discount) / 100;
            const finalAmount = itemTotal - discountAmount;
            return acc + finalAmount;
        }, 0);
    };

    const sortedOrders = [...filteredData].sort(
        (a, b) => new Date(b.invoicedate) - new Date(a.invoicedate)
    );

    const grandTotal = sortedOrders.reduce(
        (acc, order) => acc + calculateOrderTotal(order), 0
    );

    const handleDelete2 = async (id) => {
        setLoading(true);

        try {
            await axios.delete(`https://admin.bizstor.lk/public/api/delete-data/${id}`);

            await axios.delete(`https://admin.bizstor.lk/public/api/auto-delete-payment-data/${id}`).catch(error => {
                if (error.response && error.response.status === 404) {
                    console.warn(`Payment data for order ${id} not found, skipping...`);
                } else {
                    throw error;
                }
            });

            notyf.success('invoice deleted successfully!');

        } catch (error) {
            notyf.error('Error deleting invoice!');
        } finally {
            setLoading(false);
        }
    };

    return (
        <Box
            sx={{ mt: 10 }}
        >
            <AnimatedTypography
                component="h1"
                sx={{
                    ml: { xs: 2, sm: 3 }, // Adjust margins for responsiveness
                    mt: { xs: 2, sm: 3 },
                    color: '',
                    letterSpacing: '0.01em',
                    fontSize: { xs: '20px', sm: '24px' }, // Responsive font size
                }}
            >
                <Box sx={{ display: 'flex', alignItems: 'center', ml: 1 }}>
                    {/**<Typography
                        component="span"
                        sx={{
                            display: { xs: 'none', sm: 'inline' },
                            fontSize: { xs: '14px', sm: '16px' },
                            fontWeight: 'bold',
                            color: '',
                        }}
                    >
                        Order History for {fullname}
                    </Typography>
                    <Typography
                        component="span"
                        sx={{
                            display: { xs: 'none', sm: 'inline' }, // Hidden on xs
                            ml: 1,
                            fontSize: '14px',
                            color: '',
                        }}
                    >
                        |
                    </Typography>*/}
                    <HomeIcon
                        sx={{
                            ml: 1,
                            fontSize: '18px',
                            color: '#6d7081',
                        }}
                    />
                    <Typography
                        component="span"
                        sx={{
                            ml: 0.5,
                            fontSize: '14px',
                            color: '#6d7081',
                        }}
                    >
                        - Report - Customers - {fullname}
                    </Typography>
                </Box>
            </AnimatedTypography>

            {/**<AnimatedTypography
                component="h1"
                sx={{
                    ml: 5,
                    mt: 3,
                    fontSize: '1rem',      // Adjust font size as needed
                    color: 'secondary.main', // Use theme color or specify a color like '#333'
                    letterSpacing: '0.01em' // Adjust letter spacing as needed
                }}
            >
                Dashboard / Report / Customer / {fullname}
            </AnimatedTypography>*/}
            <Box
                sx={{
                    display: 'flex',
                    flexDirection: 'column',
                    width: { sm: '95%', xs: '90%' },
                    maxWidth: 'auto',
                    margin: 'auto',
                    //boxShadow: 1,
                    padding: '10px',
                    bgcolor: 'background.paper',
                    border: '1px solid #EDF2F7',
                    borderRadius: '16px',
                    marginTop: '30px',
                    position: 'relative',
                }}
            >
                <Typography variant="h4" component="h1" gutterBottom>

                </Typography>
                <Box
                    sx={{
                        display: 'flex',
                        flexDirection: 'column',
                        justifyContent: 'left',
                        alignItems: 'left',
                        '@media (max-width: 600px)': {
                            margin: 'auto',
                        },
                        color: '#1e293b',
                        ml: 2
                    }}
                >
                    <Box sx={{ textTransform: 'none' }}><h2>Order History For {fullname}</h2></Box>
                    <Box
                        component="div"
                        sx={{
                            mb: { sm: 2, xs: 'none' },
                            cursor: 'pointer',
                            display: 'inline-flex',
                            alignItems: 'center',
                            color: 'primary.main',
                            width: 'fit-content',
                            '&:hover': {
                                color: 'primary.main',
                            }
                        }}
                        onClick={handleBackClick}
                    >
                        <ArrowBackIcon fontSize="small" />
                        <Typography
                            variant="body2"
                            sx={{
                                ml: 0.5,
                                fontWeight: 500
                            }}
                        >
                            Back to Customer
                        </Typography>
                    </Box>

                </Box>

                <Box sx={{ display: 'flex', flexWrap: 'wrap', alignItems: 'center', mb: 2 }}>
                    <Box
                        sx={{
                            mt: 2,
                            '@media (max-width: 600px)': {
                                display: { xs: 'none', },
                            },
                        }}
                    >
                        <IconButton
                            onClick={handlePrint}
                            sx={{
                                display: { sm: 'none', xs: 'flex', md: 'none' }
                            }}
                        >
                            <PrintIcon />
                        </IconButton>
                        <IconButton
                            onClick={toggleSearch}
                            sx={{
                                display: { sm: 'none', xs: 'flex', md: 'none' }
                            }}
                        >
                            <SearchIcon />
                        </IconButton>
                    </Box>
                    <Box
                        sx={{
                            display: 'flex',
                            flexWrap: 'wrap',
                            gap: 2,
                            marginLeft: '20px',
                            flexDirection: { xs: 'column', sm: 'row' },
                            '@media (max-width: 600px)': {
                                margin: 'auto',
                                gap: 1,
                            },
                        }}
                    >

                        <motion.div
                            initial={{ opacity: 0, height: 0 }}
                            animate={{ opacity: isSearchOpen ? 1 : 0, height: isSearchOpen ? 'auto' : 0 }}
                            transition={{ duration: 0.3 }}
                            style={{ overflow: 'hidden', }}
                        >
                            <Box
                                sx={{
                                    display: 'flex',
                                    flexWrap: 'wrap',
                                    gap: 2,
                                    flexDirection: { xs: 'column', sm: 'row' },
                                    '@media (max-width: 600px)': {
                                        margin: 'auto',
                                        gap: 1,
                                    },
                                }}
                            >
                                <TextField
                                    variant="outlined"
                                    margin="normal"
                                    onChange={handleSearchChange}
                                    value={searchTerm}
                                    size="small"
                                    type="date"
                                    sx={{
                                        width: '250px',
                                        borderRadius: '8px',
                                        '& .MuiOutlinedInput-root': {
                                            borderRadius: '8px',
                                        },
                                    }}
                                />
                                <Select
                                    value={selectedMonth}
                                    onChange={handleMonthChange}
                                    displayEmpty
                                    size="small"
                                    sx={{
                                        width: '250px',
                                        height: '40px',
                                        mt: 2,
                                        borderRadius: '8px',
                                        '& .MuiOutlinedInput-root': {
                                            borderRadius: '8px',
                                        },
                                    }}
                                >
                                    <MenuItem value="">
                                        <em>All Months</em>
                                    </MenuItem>
                                    <MenuItem value="January">January</MenuItem>
                                    <MenuItem value="February">February</MenuItem>
                                    <MenuItem value="March">March</MenuItem>
                                    <MenuItem value="April">April</MenuItem>
                                    <MenuItem value="May">May</MenuItem>
                                    <MenuItem value="June">June</MenuItem>
                                    <MenuItem value="July">July</MenuItem>
                                    <MenuItem value="August">August</MenuItem>
                                    <MenuItem value="September">September</MenuItem>
                                    <MenuItem value="October">October</MenuItem>
                                    <MenuItem value="November">November</MenuItem>
                                    <MenuItem value="December">December</MenuItem>
                                </Select>
                            </Box>
                        </motion.div>

                    </Box>

                    <Box flexWrap="wrap" alignItems="center" sx={{ ml: 'auto', display: { xs: "flex", sm: 'none', md: 'none' } }}>
                        <Box
                            sx={{
                                mt: 2,
                                display: { sm: 'none', xs: 'flex' },
                                '@media (max-width: 600px)': {
                                    display: { xs: 'flex' },
                                },
                            }}
                        >
                            <IconButton onClick={handlePrint}>
                                <PrintIcon />
                            </IconButton>
                            <IconButton onClick={toggleSearch}>
                                <SearchIcon />
                            </IconButton>
                        </Box>
                        {customerInfo && (
                            <Box sx={{ mr: 2, display:{ sm:'flex',xs:'none'}, alignItems: 'center' }}>
                                {customerInfo.image ? (
                                    <Avatar
                                        src={`https://admin.bizstor.lk/storage/app/public/${customerInfo.image}`}
                                        alt={fullname}
                                        sx={{ width: 60, height: 60, borderRadius: '50%' }}
                                    />
                                ) : (
                                    <Avatar
                                        sx={{ width: 60, height: 60, borderRadius: '50%', bgcolor: 'grey' }}
                                    />
                                )}
                            </Box>
                        )}
                        <Box display="flex" flexDirection="column" alignItems="flex-end">
                            <Typography variant="h6"><b>Sales</b></Typography>
                            <Typography><strong>TOTAL:</strong> LKR.{Number(totalAmount) ? Number(totalAmount).toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ",") : '0.00'}</Typography>
                            <Typography><strong>TO BE PAID:</strong> LKR.{Number(totalFinalAmount) ? Number(totalFinalAmount).toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ",") : '0.00'}</Typography>
                            <Typography><strong>PAID:</strong> LKR.{(totalPaymentAmount + totalPayAmount).toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ",")}</Typography>
                            <Typography><strong>CREDIT:</strong> LKR.{(totalFinalAmount - totalPaymentAmount - totalPayAmount).toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ",")}</Typography>
                        </Box>
                    </Box>
                </Box>

                <Box
                    sx={{
                        display: { sm: 'flex', md: 'flex', xs: 'none' },
                        flexDirection: 'row',
                        justifyContent: 'space-between',
                        alignItems: 'flex-start',
                        width: '98%',
                        height: '100px',
                        margin: 'auto'
                    }}
                >
                    <Box
                        sx={{
                            bgcolor: 'white',
                            display: 'flex',
                            flexDirection: 'column',
                            width: '25%',
                            height: '120px',
                            margin: 'auto',
                            gap: 1
                        }}
                    >
                        <Typography sx={{ fontSize: '15px', fontWeight: 'bold', color: 'rgb(36, 36, 36)' }}>Total Sales</Typography>
                        <Typography sx={{ fontSize: '25px', fontWeight: 800 }}>LKR.{Number(totalAmount) ? Number(totalAmount).toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ",") : '0.00'}</Typography>
                    </Box>
                    <Box
                        sx={{
                            bgcolor: 'white',
                            display: 'flex',
                            flexDirection: 'column',
                            width: '25%',
                            height: '120px',
                            margin: 'auto',
                            gap: 1
                        }}
                    >
                        <Typography sx={{ fontSize: '15px', fontWeight: 'bold', color: 'rgb(36, 36, 36)' }}>To be paid</Typography>
                        <Typography sx={{ fontSize: '25px', fontWeight: 800 }}>LKR.{Number(totalFinalAmount) ? Number(totalFinalAmount).toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ",") : '0.00'}</Typography>
                    </Box>
                    <Box
                        sx={{
                            bgcolor: 'white',
                            display: 'flex',
                            flexDirection: 'column',
                            width: '25%',
                            height: '120px',
                            margin: 'auto',
                            gap: 1
                        }}
                    >
                        <Typography sx={{ fontSize: '15px', fontWeight: 'bold', color: 'rgb(36, 36, 36)' }}>Paid</Typography>
                        <Typography sx={{ fontSize: '25px', fontWeight: 800 }}>LKR.{(totalPaymentAmount + totalPayAmount).toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ",")}</Typography>
                    </Box>
                    <Box
                        sx={{
                            bgcolor: 'white',
                            display: 'flex',
                            flexDirection: 'column',
                            width: '25%',
                            height: '120px',
                            margin: 'auto',
                            gap: 1
                        }}
                    >
                        <Typography sx={{ fontSize: '15px', fontWeight: 'bold', color: 'rgb(36, 36, 36)' }}>Credit</Typography>
                        <Typography sx={{ fontSize: '25px', fontWeight: 800 }}>LKR.{(totalFinalAmount - totalPaymentAmount - totalPayAmount).toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ",")}</Typography>
                    </Box>
                </Box>

                <Box
                    sx={{
                        height: '25%',
                        width: '99%',
                        display: { sm: 'flex', xs: 'none', md: 'flex' },
                        mb: 3,
                        alignItems: 'center', // Center children vertically
                        margin: 'auto'
                    }}
                >
                    {/* Left side: search + select */}
                    <Box
                        sx={{
                            display: 'flex',
                            flexWrap: 'wrap',
                            gap: 2,
                            flexDirection: { xs: 'column', sm: 'row' },
                            '@media (max-width: 600px)': {
                                margin: 'auto',
                                gap: 1,
                            },
                        }}
                    >
                        <TextField
                            variant="outlined"
                            margin="normal"
                            onChange={handleSearchChange}
                            value={searchTerm}
                            size="small"
                            type="date"
                            sx={{
                                width: '250px',
                                borderRadius: '8px',
                                '& .MuiOutlinedInput-root': {
                                    borderRadius: '8px',
                                },
                            }}
                        />
                        <Select
                            value={selectedMonth}
                            onChange={handleMonthChange}
                            displayEmpty
                            size="small"
                            sx={{
                                width: '250px',
                                height: '40px',
                                mt: 2,
                                borderRadius: '8px',
                                '& .MuiOutlinedInput-root': {
                                    borderRadius: '8px',
                                },
                            }}
                        >
                            <MenuItem value=""><em>All Months</em></MenuItem>
                            <MenuItem value="January">January</MenuItem>
                            <MenuItem value="February">February</MenuItem>
                            <MenuItem value="March">March</MenuItem>
                            <MenuItem value="April">April</MenuItem>
                            <MenuItem value="May">May</MenuItem>
                            <MenuItem value="June">June</MenuItem>
                            <MenuItem value="July">July</MenuItem>
                            <MenuItem value="August">August</MenuItem>
                            <MenuItem value="September">September</MenuItem>
                            <MenuItem value="October">October</MenuItem>
                            <MenuItem value="November">November</MenuItem>
                            <MenuItem value="December">December</MenuItem>
                        </Select>
                    </Box>

                    {/* Right side: hh */}
                    <Box
                        sx={{
                            display: 'flex',
                            alignItems: 'center',
                            ml: 'auto',
                        }}
                    >
                        <IconButton onClick={handlePrint}>
                            <PrintIcon />
                        </IconButton>
                    </Box>
                </Box>

                {loading ? (
                    <Box sx={{
                        position: 'fixed',
                        top: 0,
                        left: 0,
                        width: '100vw',
                        height: '100vh',
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                        bgcolor: 'white',
                        zIndex: 9999
                    }}>
                        <l-trio
                            size="50"
                            speed="1.3"
                            color="red"
                        ></l-trio>
                    </Box>
                ) : (
                    <Box sx={{ p: 1 }}>
                        <TableContainer >
                            <Table stickyHeader>
                                <TableHead>
                                    <TableRow sx={{ '& td, & th': { padding: '9px 13px', bgcolor: '#F7FAFC' } }}>
                                        <TableCell><strong>Invoice Date</strong></TableCell>
                                        <TableCell><strong>Invoice No</strong></TableCell>
                                        <TableCell><strong>Full Name</strong></TableCell>
                                        <TableCell><strong>Term</strong></TableCell>
                                        <TableCell><strong>Due Date</strong></TableCell>
                                        <TableCell><strong>Total (LKR)</strong></TableCell>
                                        <TableCell></TableCell>
                                    </TableRow>
                                </TableHead>
                                <TableBody>
                                    {[...filteredData]
                                        .sort((a, b) => new Date(b.created_at) - new Date(a.created_at))
                                        .map((order) => {
                                            const orderTotal = calculateOrderTotal(order);

                                            return (
                                                <React.Fragment key={order.id}>
                                                    <TableRow
                                                        onClick={() => handleToggleRow(order.id)}
                                                        sx={{
                                                            cursor: 'pointer',
                                                            bgcolor: openRow === order.id ? '#f0f8ff' : 'white',
                                                            '&:hover': { padding: '9px 13px', bgcolor: '#f5f5f5' }
                                                        }}
                                                    >
                                                        <TableCell>{new Date(order.invoicedate).toLocaleDateString()}</TableCell>
                                                        <TableCell>{order.invoiceNo}</TableCell>
                                                        <TableCell>{order.fullname}</TableCell>
                                                        <TableCell>{order.term}</TableCell>
                                                        <TableCell>{new Date(order.duedate).toLocaleDateString()}</TableCell>
                                                        <TableCell>
                                                            {orderTotal.toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ",")}
                                                        </TableCell>
                                                        <TableCell>
                                                            <IconButton onClick={() => handleDelete2(order.id)} aria-label="delete"
                                                                sx={{ '&:hover': { color: 'red' } }}>
                                                                <DeleteIcon />
                                                            </IconButton>
                                                        </TableCell>
                                                    </TableRow>

                                                    <TableRow>
                                                        <TableCell colSpan={7} sx={{ paddingBottom: 0, paddingTop: 0 }}>
                                                            <Collapse in={openRow === order.id} timeout="auto" unmountOnExit>
                                                                <Box sx={{ margin: 2 }}>
                                                                    <Typography variant="subtitle1" gutterBottom color="primary">
                                                                        Order Details #{order.pay_id}
                                                                    </Typography>
                                                                    <Table size="small">
                                                                        <TableHead>
                                                                            <TableRow>
                                                                                <TableCell>Product</TableCell>
                                                                                <TableCell>Qty</TableCell>
                                                                                <TableCell>Rate</TableCell>
                                                                                <TableCell>Price</TableCell>
                                                                                <TableCell>Tax</TableCell>
                                                                                <TableCell>Discount</TableCell>
                                                                                <TableCell>Total</TableCell> {/* 👈 added column for item total */}
                                                                            </TableRow>
                                                                        </TableHead>
                                                                        <TableBody>
                                                                            {order.items.map((item, idx) => {
                                                                                const itemTax = (Number(item.price) * (item.tax / 100)) || 0;
                                                                                const itemTotal = Number(item.price) + itemTax;
                                                                                const discount = order.discount || 0;
                                                                                const discountAmount = (itemTotal * discount) / 100;
                                                                                const finalAmount = itemTotal - discountAmount;

                                                                                return (
                                                                                    <TableRow key={idx}>
                                                                                        <TableCell>{item.product}</TableCell>
                                                                                        <TableCell>{item.quantity}</TableCell>
                                                                                        <TableCell>LKR.{item.rate}</TableCell>
                                                                                        <TableCell>LKR.{Number(item.price).toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ",")}</TableCell>
                                                                                        <TableCell>{item.tax ? `${item.tax}%` : '-'}</TableCell>
                                                                                        <TableCell>{discount ? `${discount}%` : '-'}</TableCell>
                                                                                        <TableCell>
                                                                                            LKR.{finalAmount.toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ",")}
                                                                                        </TableCell>
                                                                                    </TableRow>
                                                                                );
                                                                            })}
                                                                            {/* Order Total Row */}
                                                                            <TableRow sx={{ '& td': { borderBottom: 'none' } }}>
                                                                                <TableCell colSpan={6} sx={{ textAlign: 'right', fontWeight: 'bold' }}>
                                                                                    Grand Total
                                                                                </TableCell>
                                                                                <TableCell sx={{ fontWeight: 'bold', borderBottom: 'none' }}>
                                                                                    LKR.{order.items.reduce((sum, item) => {
                                                                                        const itemTax = (Number(item.price) * (item.tax / 100)) || 0;
                                                                                        const itemTotal = Number(item.price) + itemTax;
                                                                                        const discount = order.discount || 0;
                                                                                        const discountAmount = (itemTotal * discount) / 100;
                                                                                        const finalAmount = itemTotal - discountAmount;
                                                                                        return sum + finalAmount;
                                                                                    }, 0).toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ",")}
                                                                                </TableCell>
                                                                            </TableRow>
                                                                        </TableBody>
                                                                    </Table>
                                                                </Box>
                                                            </Collapse>
                                                        </TableCell>
                                                    </TableRow>
                                                </React.Fragment>
                                            );
                                        })}
                                </TableBody>
                            </Table>
                        </TableContainer>


                        <Box sx={{ display: 'flex', justifyContent: 'flex-end', mt: 2 }}>
                            <Box
                                display="flex"
                                justifyContent="center"
                                width="100%"
                                mt={2}
                            >
                                <TablePagination
                                    rowsPerPageOptions={[100, 200, 300]}
                                    component="div"
                                    count={filteredData.length}
                                    page={page}
                                    rowsPerPage={rowsPerPage}
                                    onPageChange={handleChangePage}
                                    onRowsPerPageChange={handleChangeRowsPerPage}
                                    labelRowsPerPage=""
                                />
                            </Box>
                        </Box>
                    </Box>
                )}
            </Box>
            <ScrollToTopButton />
        </Box>
    );
};

export default OrderHistory;
